import type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";
import type { IConfirmation } from "@pulse-ui/codegen-v2/generated_ts/drop_copy";
import { api } from "../base";

export interface ISendConfirmationArgs {
  counterpartyType: "client" | "lp";
  channels: string;
  // The account to route on is read from confirmation.account by the backend.
  confirmation: IConfirmation;
}

const beaconEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    // POST /api/beacon/v1/send_confirmation/{counterparty_type}?channels=...
    sendConfirmation: build.mutation<IPulseApiResponse, ISendConfirmationArgs>({
      query: ({ counterpartyType, channels, confirmation }) => ({
        url: `/api/beacon/v1/send_confirmation/${encodeURIComponent(counterpartyType)}`,
        method: "POST",
        params: { channels },
        body: confirmation,
      }),
    }),
  }),
});

export const { useSendConfirmationMutation } = beaconEndpoints;
export type { IConfirmation } from "@pulse-ui/codegen-v2/generated_ts/drop_copy";
